module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "application"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('NavBar')], 1), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.breadcrumbs), function(breadcrumb, index) {
    return _c('el-breadcrumb-item', {
      key: index,
      attrs: {
        "to": breadcrumb.path
      }
    }, [_vm._v(_vm._s(breadcrumb.name))])
  }), 1)], 1), _c('div', {
    staticClass: "side-menu"
  }, [_c('SideBar')], 1), _c('div', {
    staticClass: "main-content"
  }, [_vm._t("default")], 2)]), _c('div', {
    staticClass: "footer"
  }, [_c('Footer')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-120c143b","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/CenterLayout.vue
// module id = 563
// module chunks = 85